import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function messageSendingsRoutes($stateProvider: StateProvider) {
    let componentModule: { default: any; };

    $stateProvider
        .state('messages', {
            url: '/messages',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => componentModule.default
            },
            lazyLoad: async () => {
                componentModule = await import(/* webpackChunkName: "messages" */ './KpMessagesPage.svelte');
                return null;
            }
        });
}